


















































































import {
  defineComponent,
  ref,
  computed,
  PropType,
  inject,
} from '@vue/composition-api';
import { FormSpelling, DictionaryForm } from '@oare/types';
import sl from '@/serviceLocator';
import UtilList from '@/components/UtilList/index.vue';
import TextOccurrences from '@/components/TextOccurrences/index.vue';
import { ReloadKey } from '../../../../../index.vue';
import EventBus, { ACTIONS } from '@/EventBus';

export default defineComponent({
  components: {
    UtilList,
    TextOccurrences,
  },
  props: {
    spelling: {
      type: Object as PropType<FormSpelling>,
      required: true,
    },
    form: {
      type: Object as PropType<DictionaryForm>,
      required: true,
    },
    uuidToHighlight: {
      type: String,
      default: null,
    },
    allowEditing: {
      type: Boolean,
      default: true,
    },
    spellingOccurrencesCount: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const _ = sl.get('lodash');
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const store = sl.get('store');
    const reload = inject(ReloadKey);
    const router = sl.get('router');

    const routeName = router.currentRoute.name;

    const textOccurrenceDialog = ref(false);
    const deleteSpellingDialog = ref(false);
    const deleteLoading = ref(false);
    const isEditing = ref(false);
    const isCommenting = ref(false);

    const canEdit = computed(() => store.hasPermission('UPDATE_FORM'));

    const canComment = computed(() => store.hasPermission('ADD_COMMENTS'));

    const deleteSpelling = async () => {
      try {
        await server.removeSpelling(props.spelling.uuid);
        actions.showSnackbar('Successfully removed spelling');
        reload && reload();
      } catch (err) {
        actions.showErrorSnackbar('Failed to delete spelling', err as Error);
      } finally {
        deleteSpellingDialog.value = false;
      }
    };

    const openComment = (uuid: string, word: string) => {
      EventBus.$emit(ACTIONS.COMMENT_DIALOG, {
        uuid,
        word,
      });
    };

    const openEditDialog = (form: DictionaryForm, spelling: FormSpelling) => {
      EventBus.$emit(ACTIONS.EDIT_WORD_DIALOG, {
        form,
        spelling,
        allowDiscourseMode: true,
      });
    };

    const disconnectSpellings = async (discourseUuids: string[]) => {
      try {
        await server.disconnectSpellings(discourseUuids);
      } catch (err) {
        actions.showErrorSnackbar(
          'Error disconnecting spellings. Please try again.',
          err as Error
        );
      }
    };

    return {
      server,
      textOccurrenceDialog,
      deleteLoading,
      canEdit,
      isEditing,
      canComment,
      isCommenting,
      deleteSpellingDialog,
      deleteSpelling,
      routeName,
      openComment,
      openEditDialog,
      reload,
      disconnectSpellings,
    };
  },
});
